import { FC } from 'react';
import styled from 'styled-components';

interface HamburgerProps {
  toggleMenu: () => void;
}

const HamburgerButton = styled.button`
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-right: 15px;

  /* Show hamburger button on mobile */
  @media (max-width: 600px) {
    display: flex;
  }
`;

const Bar = styled.span`
  width: 100%;
  height: 3px;
  background-color: ${({ theme }) => theme.fontColor || '#ffffff'};
`;

const Hamburger: FC<HamburgerProps> = ({ toggleMenu }) => {
  return (
    <HamburgerButton onClick={() => toggleMenu()}>
      <Bar />
      <Bar />
      <Bar />
    </HamburgerButton>
  );
};

export default Hamburger;
